import React from 'react';
import './OurTeam.scss';
import TeamOrbit from "./TeamOrbit/TeamOrbit";

function OurTeam() {

    return (
        <div className="OurTeam modal-bg">
            <div className="content">
                <div className={'titleKey'}>Engineering Team</div>
                <div className={'title'}>
                    <div>Compact senior engineering team.<br/>
                         Architecture-level impact.</div>
                </div>
                <div className={'underTitleText'}>
                    Tahion operates as a focused group of experienced engineers <br/>
                    and system architects delivering reliable solutions for complex environments.
                </div>
                {/*<div className={'subtitle'}>The core team</div>*/}
                <TeamOrbit />
            </div>
        </div>
    );
}

export default OurTeam;